import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function SDK() {
  return (
    <PageLayout
      title="Native SDKs & Libraries"
      subtitle="Pre-built integrations for iOS, Android, and Windows/Linux environments."
      badge="LIBRARIES"
      imageSrc="/products/art_sdk_1776905163173.png"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-16">
        {['iOS (Swift)', 'Android (Kotlin)', 'React Native', 'C# / .NET'].map(tech => (
          <div key={tech} className="bg-white p-6 rounded-2xl border border-gray-100 text-center hover:shadow-lg transition-shadow cursor-pointer">
            <h4 className="font-bold text-gray-900">{tech}</h4>
            <p className="text-sm text-gray-500 mt-2">View Repository &rarr;</p>
          </div>
        ))}
      </div>
    </PageLayout>
  );
}
